import React from 'react'
import postIcon from '../../../imgs/post.svg'
import toparrow from '../../../imgs/akar-icon.svg'


const HomeCard = ({
    bounty
}) => {
    const { fullName, company, title, bountyType, demandPrice, department, reason } = bounty
    return (
        <div className="feed-card-wrapper">
            <div>
                <div className="row m-0 justify-content-between">
                    <h2 className="heading"><img src={postIcon} alt="logo" />{bountyType == 'person' ? fullName : company}</h2>
                    <h2 className="small-heading">${demandPrice}</h2>
                </div>
                <p className="color-black">{bountyType == 'person' ? `${title} at ${company} ` : department}</p>
            </div>
            <div className="row m-0 justify-content-between">
                <span>For {reason}</span>
                <a><img src={toparrow} alt="logo" />Make intro</a>
            </div>
        </div>
    )
}

export default HomeCard;
